/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-call */
import React, { useEffect, useState } from 'react';
import CustomDataTable from '../CustomDataTable/CustomDataTable';
import { updatestatus, getAlllisttrigger, deletelisttrigger, copylisttrigger, updatePauseResumeStatus, getTriggerReportData, exportTriggerStandardReport } from 'src/services/triggerService';
import CsvService from 'src/services/dataExport.service';
import { Autocomplete, Grid, IconButton, Menu, MenuItem, TextField } from '@mui/material';
import type { TableColumn } from 'react-data-table-component';
import MUIModal from '../MUIModal/MUIModal';
import AddTriggerForm from './AddTriggerForm';
import GradientButton from '../MUICustomButton/GradientButton';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import { styled } from '@mui/material/styles';
import { ARE_YOU_SURE, DELETE_TRIGGER, ACTIVATE_TRIGGER_SUCCESS_MESSAGE, COPY_TRIGGER_SUCCESS_MESSAGE, DEACTIVATE_TRIGGER_SUCCESS_MESSAGE, DELETE_TRIGGER_SUCCESS_MESSAGE, COPY_TRIGGER, RESUME_TRIGGER_SUCCESS_MESSAGE, PAUSE_TRIGGER_SUCCESS_MESSAGE } from 'src/constants/constant';
import OutlineButton from '../MUICustomButton/OutlineButton';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { NotificationManager } from 'react-notifications';
import { useSelector } from 'react-redux';
import type { RootState, TriggerResponse, appConfigs } from '../types/types';
import { FormControl } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom'
import moment from 'moment';
import { getAllCampaigns } from 'src/services/campaignService';
//@ts-ignore
import { HugeiconsIcon } from '@hugeicons/react';
//@ts-ignore
import { MoreVerticalSolidRounded } from '@hugeicons-pro/core-solid-rounded';
//@ts-ignore
import { MultiplicationSignStrokeStandard, ArrowDown01Icon } from '@hugeicons-pro/core-stroke-standard';
//@ts-ignore
import TemplatePreview from '../TemplatePreview/TemplatePreview'; // Import your modal component
//@ts-ignore
import { ViewStrokeRounded, Image03Icon, PencilEdit02Icon } from '@hugeicons-pro/core-stroke-rounded';
import {checkEventPermission} from "../../common/utility/utility";
import CustomTooltip from '../CustomTooltip/CustomTooltip';
import ExportTriggerCustomReport from './ExportTriggerCustomReport';
import { buildReportFileName } from '../utils/buildReportFileName';


const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

interface TriggerListPropType {
  id: number;
  clientId?: number;
  clientName?: string;
  campaignId?: number;
  campaignName: string;
  templateId?: number;
  templateName?: string;
  templateContent: string;
  templateIdentifier?: string;
  listTriggerName: string;
  startDate: string;
  endDate: string;
  totalNPI: number;
  listFileName?: string;
  parentId?: number;
  isActive: boolean;
  isPaused: boolean;
  pausedOn: string;
  pausedBy: number;
  resumedOn?: string;
  resumedBy?: number;
  createdOn?: string;
  createdBy?: number;
  createdByUserName?: string;
  updatedOn?: string;
  updatedBy?: number;
  updatedByUserName?: string;
  isDeleted: boolean;
  deletedOn?: string;
  deletedBy?: number;
  matchedNPI: number;
  sent: number;
  open: number;
  clicks: number;
  unSubscribe: number;
}

interface ApiResponse {
  status: number;
  data: {
    data: TriggerListPropType[];
    result: number;
  };
}


const TriggerList: React.FC = () => {

  const [triggerListData, setTriggerListData] = useState<TriggerListPropType[]>([])
  const [templateSearchData, setTriggerSearchData] = useState<TriggerListPropType[]>([])
  const [openAddTemplateModal, setOpenAddTemplateModal] = useState<boolean>(false)
  const [loading, setLoading] = useState<boolean>(true)
  const [isModalSaveLoading, setIsModalSaveLoading] = useState<boolean>(false)
  const [templateInfoData, setTemplateInfoData] = useState<any>();
  const [showDeleteTemplateModal, setDeleteTemplateModal] = useState<boolean>(false);
  const [showDeactivateTemplateModal, setDeactivateTemplateModal] = useState<boolean>(false);
  const [showCopyTemplateModal, setCopyTemplateModal] = useState<boolean>(false);
  const [campaigns, setTriggers] = useState<any>([]);
  const [updatePauseResume, setUpdatePauseResume] = useState<boolean>(false);
  const [updateType, setUpdateType] = useState<string>("");
  const [filterState, setFilterState] = useState({
    searchText: "",
    campaignId: null,
    status: null
  });
  const [isPreviewModalOpen, setIsPreviewModalOpen] = useState(false);
  const [previewContent, setPreviewContent] = useState('');
  const storedAppConfig = localStorage.getItem("appConfigs");

  const [customReportModal, setCustomReportModal] = useState<boolean>(false)
  const [triggerId, setTriggerId] = useState<any>()
  const [triggerName, setTriggerName] = useState<string>("")


  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [anchorActionEl, setAnchorActionEl] = React.useState<any>({});
  const { user } = useSelector((state: RootState) => state.auth);

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const userData = JSON.parse(localStorage.getItem("user"));
  const navigate = useNavigate()

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    getTriggerListData()
  }, [user])

  useEffect(() => {
    const ClientId = user?.clientId ?? 0;
    getAllCampaigns(ClientId)
      .then(
        (res: TriggerResponse) => {
          if (res.status === 200) {
            if (res.data.result === 1) {
              const brandArr: TriggerResponse[] = [];
              res.data.data
                .filter((brand: any) => brand.isActive) // Filter only active items
                .map((brand: any) => {
                  brand.Name = `${brand.clientName}`;
                  brandArr.push(brand);
                });
              setTriggers(brandArr)
            } else {
              setTriggers([])
            }
          }
        }
      )
      .catch(
        (error: any) => console.log("Error: ", error)
      )
  }, [user])
  const applyFilters = (data: TriggerListPropType[], filters: any): TriggerListPropType[] => {
    let filteredData = [...data];
    // Apply search text filter
    if (filters.searchText != null) {
      const trimmedSearchText = filters.searchText.trim();
      filteredData = filteredData.filter((trigger) => {
        const matchesName = trigger.listTriggerName.toLowerCase().includes(trimmedSearchText.toLowerCase());
        const matchesId = trigger.id.toString().includes(trimmedSearchText);
        return matchesName || matchesId;
      });
    }

    // Apply campaign filter
    if (filters.campaignId != null) {
      filteredData = filteredData.filter((trigger) =>
        trigger.campaignId === filters.campaignId
      );
    }

    // Apply status filter
    if (filters.status !== null) {
      const isActive = filters.status === 'active';
      filteredData = filteredData.filter((trigger) =>
        trigger.isActive === isActive
      );
    }

    return filteredData;
  };

  // Update getTriggerListData to reset filters
  const getTriggerListData = (): void => {
    setLoading(true);
    const ClientId = user?.clientId ?? 0;

    getAlllisttrigger(ClientId)
      .then((res: ApiResponse) => {
        if (res.status === 200) {
          if (res.data.result === 1) {
            const campaignArr: TriggerListPropType[] = res.data.data.map((campaign: any) => ({
              ...campaign,
              Name: campaign.name
            }));
            setTriggerListData(campaignArr);
            setTriggerSearchData(campaignArr);

            // Reset filter state
            setFilterState({
              searchText: "",
              campaignId: null,
              status: null
            });
          } else {
            setTriggerListData([]);
            setTriggerSearchData([]);
          }
        }
      })
      .catch((error: any) => console.log("Error: ", error))
      .finally(() => setLoading(false));
  };
  const handleAddTemplateClick = (): void => {
    navigate('/trigger/new-trigger')
  }

  const handleCloseAddTemplateModal = (): void => {
    setOpenAddTemplateModal(false)
  }

  const handleActionClick = (event: React.MouseEvent<HTMLElement>, id: number): void => {
    // anchorActionEl[id] = event.currentTarget
    setAnchorActionEl({ ...anchorActionEl, [id]: event.currentTarget });
  }

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const searchText = e.target.value;
    setFilterState(prev => ({ ...prev, searchText }));

    const newFilters = {
      ...filterState,
      searchText
    };

    const filteredData = applyFilters(triggerListData, newFilters);
    setTriggerSearchData(filteredData);
  };

  const handleSearchByTrigger = (selectedCampaign: any | null): void => {
    // If selectedCampaign is null (cleared) or empty string, reset the campaign filter
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    const campaignId = selectedCampaign?.campaignId || null;
    setFilterState(prev => ({ ...prev, campaignId }));

    const newFilters = {
      ...filterState,
      campaignId
    };

    const filteredData = applyFilters(triggerListData, newFilters);
    setTriggerSearchData(filteredData);
  };

  const handleDeleteTemplate = (id: number, templateName: string): void => {
    setTemplateInfoData({ id, templateName });
    setDeleteTemplateModal(true)
    setAnchorActionEl(null);
    setAnchorActionEl({ ...anchorActionEl, [id]: null });
  }

  const handleDeleteTemplateClose = (): void => {
    setDeleteTemplateModal(false)
  }

  const handleDeleteTemplateConfirm = (): void => {
    setIsModalSaveLoading(true)

    const { id } = templateInfoData;

    const data = {
      "deletedBy": userData.id,
      "triggerLst": [
        {
          "listTriggerId": id
        }
      ],
    }

    deletelisttrigger(data)
      .then(
        (res: ApiResponse) => {
          if (res.status === 200) {
            if (res.data.result === 1) {
              NotificationManager.success(DELETE_TRIGGER_SUCCESS_MESSAGE, '', 5000);
              setDeleteTemplateModal(false)
              getTriggerListData()
            }
          }
        }
      )
      .catch((error: any) => console.log("Error", error))
      .finally(() => setIsModalSaveLoading(false))
  }

  const handleupdatestatus = (id: number, statusId: boolean, templateName: string): void => {
    setTemplateInfoData({ id: id, newStatus: statusId, templateName: templateName });

    // Trigger the modal and close any open action menus
    setDeactivateTemplateModal(true);
    setAnchorActionEl(null);
    setAnchorActionEl({ ...anchorActionEl, [id]: null });
  };

  const handleupdatestatusClose = (): void => {
    setDeactivateTemplateModal(false)
  }
  const handleUpdatePauseResumeClose = (): void => {
    setUpdatePauseResume(false)
  }
  const handleUpdatePauseResume = (id: number, type: string): void => {
    setTemplateInfoData({ id, type });
    setUpdatePauseResume(true);
    setUpdateType(type);
    setAnchorActionEl(null);
    setAnchorActionEl({ ...anchorActionEl, [id]: null });
  }
  const handleUpdatePauseResumeConfirm = (): void => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const userData = JSON.parse(localStorage.getItem("user"));
    const { id } = templateInfoData;
    const data = {
      "updatedBy": userData.id,
      "triggerLst": [
        {
          "listTriggerId": id
        }
      ],
      "status": updateType
    }
    updatePauseResumeStatus(data)
      .then(
        (res: ApiResponse) => {
          if (res.status === 200) {
            if (res.data.result === 1) {
              if (updateType == "resume") {
                NotificationManager.success(RESUME_TRIGGER_SUCCESS_MESSAGE, '', 5000);
              } else {
                NotificationManager.success(PAUSE_TRIGGER_SUCCESS_MESSAGE, '', 5000);
                // Adjust the width inline
                setTimeout(() => {
                  const notification = document.querySelector('.notification-container') as HTMLElement | null;
                  if (notification !== null) {
                    notification.style.width = '340px'; // Set your desired width
                  }
                }, 0);
              }
              setUpdatePauseResume(false)
              getTriggerListData()
            }
          }
        }
      )
      .catch((error: any) => console.log("Error", error))
      .finally(() => setIsModalSaveLoading(false))
    setLoading(true);

  }
  const handleUpdateStatusConfirm = (): void => {
    setIsModalSaveLoading(true)

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const userData = JSON.parse(localStorage.getItem("user"))
    const { id, newStatus } = templateInfoData;
    const data = {
      "updatedBy": userData.id,
      "triggerLst": [
        {
          "listTriggerId": id
        }
      ],
      "status": newStatus === false ? 1 : 0
    }

    updatestatus(data)
      .then(
        (res: ApiResponse) => {
          if (res.status === 200) {
            if (res.data.result === 1) {
              if (newStatus == 1) {
                NotificationManager.success(DEACTIVATE_TRIGGER_SUCCESS_MESSAGE, '', 5000);
              } else {
                NotificationManager.success(ACTIVATE_TRIGGER_SUCCESS_MESSAGE, '', 5000);
                // Adjust the width inline
                setTimeout(() => {
                  const notification = document.querySelector('.notification-container') as HTMLElement | null;
                  if (notification !== null) {
                    notification.style.width = '340px'; // Set your desired width
                  }
                }, 0);
              }
              setDeactivateTemplateModal(false)
              getTriggerListData()
            }
          }
        }
      )
      .catch((error: any) => console.log("Error", error))
      .finally(() => setIsModalSaveLoading(false))
  }

  const handleCopyTemplate = (id: number, templateName: string): void => {
    setTemplateInfoData({ id, templateName });
    setCopyTemplateModal(true)
    setAnchorActionEl(null);
    setAnchorActionEl({ ...anchorActionEl, [id]: null });
  }

  const handleCopyTemplateClose = (): void => {
    setCopyTemplateModal(false)
  }

  const handleCopyTemplateConfirm = (): void => {
    setIsModalSaveLoading(true)

    const { id } = templateInfoData;

    copylisttrigger(id, userData.id)
      .then(
        (res: ApiResponse) => {
          if (res.status === 200) {
            if (res.data.result === 1) {
              NotificationManager.success(COPY_TRIGGER_SUCCESS_MESSAGE, '', 5000);
              setCopyTemplateModal(false)
              getTriggerListData()
            }
          }
        }
      )
      .catch((error: any) => console.log("Error", error))
      .finally(() => setIsModalSaveLoading(false))
  }

  const handleTemplateValue = (newValue: { value: string; label: string } | null): void => {
    const status = newValue ? newValue.value : null;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    //@ts-ignore
    setFilterState(prev => ({ ...prev, status }));

    const newFilters = {
      ...filterState,
      status
    };

    const filteredData = applyFilters(triggerListData, newFilters);
    setTriggerSearchData(filteredData);
  };

  // Dropdown options
  const options = [
    { value: 'active', label: 'Active' },
    { value: 'inactive', label: 'Inactive' },
  ];
  const handleEditNavigation = (id: number): void => {
    navigate(`/trigger/edit-trigger/${id}`);
  }

  const handleViewReport = (id: number, start: any, end: any, triggerName: string, type: string): void => {
    navigate(`/trigger/view-report/${id}`, {
      state: { start, end, triggerName, type},
    });
  }

  const handleDownloadReport = (id: any, listTriggerName: string): void => {
    getTriggerReportData(id)
      .then((res: any) => {
        if (res.status === 200) {
          if (res.data.result === 1) {
            const reportData = res.data.data;

            const data: any = [];
            if (reportData.length > 0) {


              reportData.map((item: any) => {
                const newItem = {
                  "Campaign Id": item.campaignId,
                  "Event Id": item.eventId,
                  "Event Type": item.eventType,
                  "Event Time": moment(item.eventTime).format("MM-DD-YYYY HH:mm:ss") ,
                  "Event Data": item.eventData,
                  "NPI": item.npi,
                  "Template Id": item.templateId,
                  "From Name": item.fromName,
                  "Client": item.client
                }

                data.push(newItem)
              })

              const csvData = CsvService.jsonToCsv(data);
              CsvService.downloadCsvFile(csvData, buildReportFileName(id, listTriggerName, 'SummaryReport'));
            } else {
              NotificationManager.error('No data available for download', '', 5000);
            }
          } else {
            NotificationManager.error('No data available for download', '', 5000);
          }
        }
      }).finally(() => {
          setAnchorActionEl(null);
          setAnchorActionEl({ ...anchorActionEl, [id]: null });
      })

  }

  const handleDownloadStandardReport = (id: any, name: any): void => {
    exportTriggerStandardReport(id)
        .then((res: any) => {
            if (res.status === 200) {
                if (res.data.result === 1) {
                    const reportData = res.data.data;

                    const data: any = [];
                    if (reportData.length > 0) {

                        reportData.map((item: any) => {
                            const newItem = {
                                "NPI": item.npi,
                                "First Name": item.firstName,
                                "Last Name": item.lastName,
                                "Title": item.title,
                                "Speciality": item.specialty,
                                "Event Time": moment(item.eventTime).format("MM-DD-YYYY HH:mm:ss") ,
                                "Event Type": item.eventType,
                                
                            }

                            data.push(newItem)
                        })
                  
                        const csvData = CsvService.jsonToCsv(data);
                        CsvService.downloadCsvFile(csvData, buildReportFileName(id, name, 'StandardReport'));
                    } else {
                        NotificationManager.error('No data available for download', '', 5000);
                    }
                } else {
                    NotificationManager.error('No data available for download', '', 5000);
                }
            }
        }).finally(() => {
            setAnchorActionEl(null);
            setAnchorActionEl({ ...anchorActionEl, [id]: null });
        })
}

const handleCustomReport = (id: any, name: string): void => {
  setTriggerId(id);
  setTriggerName(name)
  setCustomReportModal(true)
  setAnchorActionEl(null);
  setAnchorActionEl({ ...anchorActionEl, [id]: null });
}

const handleCloseCustomReport = (): void => {
  setCustomReportModal(false)
}

  const columns: TableColumn<TriggerListPropType>[] = [
    {
      name: 'Template',
      center: true,
      cell: (row: any) => {
        let imageUrl: string | null = null;

        if (storedAppConfig != null) {
          try {
            const parsedAppConfig = JSON.parse(storedAppConfig) as appConfigs[];
            const TemplateImagePublicURL = parsedAppConfig.find(
              (item) => item.configName === "TemplateImagePublicURL"
            )?.configValue;
            if (TemplateImagePublicURL != '') {
              imageUrl = `${TemplateImagePublicURL}Template/${row.templateIdentifier}/${row.templateHTMLVersion}/Template_Short.png`;
            }
          } catch (error) {
            console.error("Error parsing appConfig data:", error);
          }
        }

        const handlePreview = (): void => {
          if (row.templateContent) {
            setPreviewContent(row.templateContent);
            setIsPreviewModalOpen(true);
          }
        };

        return (
          <div className="relative w-[90px] h-[90px] flex items-center justify-center cursor-pointer" onClick={handlePreview}>
            {(imageUrl != null) ? (
              <img
                src={imageUrl}
                width={90}
                height={90}
                alt="Preview"
                className="icon-hover"
                onLoad={(e) => {
                  // Ensure the image is displayed when successfully loaded
                  e.currentTarget.style.display = 'block';
                }}
                onError={(e) => {
                  e.currentTarget.style.display = 'none'; // Hide broken image
                  const iconElement = e.currentTarget.nextElementSibling as HTMLElement;
                  if (iconElement) iconElement.style.display = 'flex'; // Show fallback icon
                }}
                style={{ borderRadius: '8px', objectFit: 'cover' }}
              />
            ) : null}
            <HugeiconsIcon
              icon={Image03Icon}
              size={24}
              color="#6B7280"
              className="hidden" // Initially hidden, shown if image fails
            />
            <div
              className={`absolute inset-0 flex items-center justify-center bg-black bg-opacity-50 opacity-0 rounded-lg ${row.templateContent !== "" ? 'hover:opacity-100 transition-opacity cursor-pointer' : ''}`}
            >
              <HugeiconsIcon
                icon={ViewStrokeRounded}
                size={24}
                color="white"
                strokeWidth={0.5}
                className={`cursor-pointer ${(row.templateContent === "") ? 'opacity-50 cursor-not-allowed' : ''}`}
                onClick={(e) => {
                  e.stopPropagation(); // Prevents double triggering of handlePreview
                  handlePreview();
                }}
              />
            </div>
          </div>
        );
      },
      width: '8%',
      sortable: false
    },
    {
      name: 'List Trigger',
      selector: (row: TriggerListPropType) => row.listTriggerName,
      cell: (row: any) => {
        const hasTriggerStarted = new Date(row.startDate) <= new Date(); // Check if startDate is in the past or today
        const startDate = moment(row.startDate).format('MM/DD/YYYY');
        const endDate = moment(row.endDate).format('MM/DD/YYYY');

        return (
          <div className="flex py-4 first:pt-0 last:pb-0" style={{ width: '100%' }}>
            <div className="overflow-hidden" style={{ width: '100%' }}>
              {/* Clickable Name - No Disabling */}
              <CustomTooltip title={row.listTriggerName} placement="bottom">
                <p
                  className="text-14 font-semibold text-muted underline leading-[22px]"
                  onClick={() => handleEditNavigation(row.id)}
                  style={{
                    cursor: 'pointer',
                    opacity: 1,
                    display: '-webkit-box',
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: 'vertical',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis'

                  }}
                >
                  {row.listTriggerName}
                </p>
              </CustomTooltip>

              {/* ID Display */}
              <p className="text-14 text-muted">
                <span className='font-semibold'>ID:</span> {row.id}
              </p>

              {/* Conditionally Render View Report */}
              {(hasTriggerStarted && checkEventPermission('LISTTRIGGER_VIEW_REPORT')) && (
                <div
                  className="badge truncate"
                  style={{
                    background: '#FFF5F6',
                    padding: '10px 15px',
                    color: '#F13139',
                    border: '0px',
                    cursor: 'pointer',
                    fontSize: '12px',
                    marginTop: '10px'
                  }}
                  onClick={() => handleViewReport(row.id, startDate, endDate, row.listTriggerName, "listtrigger")}
                >
                  View Report
                </div>
              )}
            </div>
          </div>
        );
      },
      width: '11%',
      sortable: true
    },
    {
      name: 'Schedule',
      selector: (row: TriggerListPropType) => row.startDate,
      width: '9%',
      cell: (row: any) => {
        return (
          <div className="flex py-4 first:pt-0 last:pb-0" style={{ width: '100%' }}>
            <div className="overflow-hidden" style={{ width: '100%' }}>
              {row.startDate && row.endDate && (
                <>
                  <p className="text-14 text-muted">
                    <span className='font-semibold'>Start: </span>{moment(row.startDate).format('L')}
                  </p>
                  <p className="text-14 text-muted">
                    <span className='font-semibold'>End: </span>{moment(row.endDate).format('L')}
                  </p>
                </>
              )}
            </div>
          </div>
        )
      },
    },
    {
      name: 'Campagin Name',
      selector: (row: TriggerListPropType) => row.campaignName,
      width: '10%',
      sortable: true,
      cell: (row: any) => {
        return (
          <div className="flex py-4 first:pt-0 last:pb-0" style={{ width: '100%' }}>
            
            <div className="overflow-hidden text-ellipsis whitespace-nowrap text-14 text-muted" style={{ width: '100%' }}>
              <CustomTooltip title={row.campaignName} placement="bottom" arrow={false}>
                <p className='overflow-hidden text-ellipsis whitespace-nowrap w-full'>{row.campaignName}</p>
              </CustomTooltip>
            </div>
            
          </div>
        )
      }
    },
    {
      name: 'Status',
      selector: (row: TriggerListPropType) => row.isActive,
      width: '7%',
      center: true,
      cell: (row: any) => {
        return row.isActive === true ? <div className="badge truncate" style={{
          background: '#CCFFEA',
          padding: '10px 15px',
          color: '#06A864',
          border: '0px'
        }}>Active</div> : <div className="badge truncate" style={{
          background: '#FFF5F6',
          padding: '10px 15px',
          color: '#F13139',
          border: '0px'
        }}>Inactive</div>
      },
    },
    {
      name: 'Total NPI',
      sortable: false,
      width: '8%',
      cell: (row: TriggerListPropType) => {
        return (
          <div className="flex py-4 first:pt-0 last:pb-0 text-center" style={{ width: '100%' }}>
            <div className="overflow-hidden" style={{ width: '100%' }}>
              <p className="text-14 text-muted"><span className='font-semibold'>{row.totalNPI}</span></p>
            </div>
          </div>
        )
      },
      center: true
    },
    {
      name: 'Matched NPI',
      sortable: false,
      width: '8%',
      cell: (row: TriggerListPropType) => {
        return (
          <div className="flex py-4 first:pt-0 last:pb-0 text-center" style={{ width: '100%' }}>
            <div className="overflow-hidden" style={{ width: '100%' }}>
              <p className="text-14 text-muted"><span className='font-semibold'>{row.matchedNPI}</span></p>
            </div>
          </div>
        )
      },
      center: true
    },
    {
      name: 'Sent',
      sortable: false,
      width: '8%',
      cell: (row: TriggerListPropType) => {
        return (
          <div className="flex py-4 first:pt-0 last:pb-0 text-center" style={{ width: '100%' }}>
            <div className="overflow-hidden" style={{ width: '100%' }}>
              <p className="text-14 text-muted"><span className='font-semibold'>{row.sent}</span></p>
            </div>
          </div>
        )
      },
      center: true
    },
    {
      name: 'Opens',
      sortable: false,
      width: '8%',
      cell: (row: any) => {
        return (
          <div className="flex py-4 first:pt-0 last:pb-0 text-center" style={{ width: '100%' }}>
            <div className="overflow-hidden" style={{ width: '100%' }}>
              <p className="text-14 text-muted"><span className='font-semibold'>{row.open}</span></p>
              <p className="text-14 text-muted">{row.openRate}%</p>
            </div>
          </div>
        )
      },
      center: true
    },
    {
      name: 'Clicks',
      sortable: false,
      width: '8%',
      cell: (row: any) => {
        return (
          <div className="flex py-4 first:pt-0 last:pb-0 text-center" style={{ width: '100%' }}>
            <div className="overflow-hidden" style={{ width: '100%' }}>
              <p className="text-14 text-muted"><span className='font-semibold'>{row.clicks}</span></p>
              <p className="text-14 text-muted">{row.clickRate}%</p>
            </div>
          </div>
        )
      },
      center: true
    },
    {
      name: 'Unsubscribes',
      selector: (row: any) => row.unSubscribe,
      width: '8%',
      cell: (row: any) => {
        return (
          <div className="flex py-4 first:pt-0 last:pb-0 text-center" style={{ width: '100%' }}>
            <div className="overflow-hidden" style={{ width: '100%' }}>
              <p className="text-14 text-muted"><span className='font-semibold'>{row.unSubscribe}</span></p>
              <p className="text-14 text-muted">{row.unsubscribeRate}%</p>
            </div>
          </div>
        )
      },
      center: true
    },
    {
      name: 'Actions',
      width: '7%',
      cell: (row: TriggerListPropType) => {
        const hasAnyPermission =
  (row.isActive === true && checkEventPermission('LISTTRIGGER_PAUSE')) ||
  checkEventPermission('LISTTRIGGER_ACTIVE') ||
  checkEventPermission('LISTTRIGGER_DUPLICATE') ||
  (checkEventPermission('LISTTRIGGER_DOWNLOAD_STANDARD_REPORT') && moment(row.startDate).isBefore(moment())) ||
  (checkEventPermission('LISTTRIGGER_DOWNLOAD_CUSTOM_REPORT') && moment(row.startDate).isBefore(moment())) ||
  (checkEventPermission('LISTTRIGGER_DOWNLOAD_REPORT') && moment(row.startDate).isBefore(moment())) ||
  checkEventPermission('LISTTRIGGER_DELETE');

      

        return (
          <div className='flex items-center'>
            <div className="icon-hover-container">
              <Link to={`/trigger/edit-trigger/${row.id}`} state={{ clientData: row }}>
                <HugeiconsIcon
                  icon={PencilEdit02Icon}
                  size={20}
                  color="#3A3A3A"
                  strokeWidth={0.2}
                />
              </Link>
            </div>
            {hasAnyPermission &&
            <div className='flex'>
              <IconButton
                aria-label="more"
                id="long-button"
                aria-haspopup="true"
                onClick={(e) => handleActionClick(e, row.id)}
              >
                <HugeiconsIcon
                  icon={MoreVerticalSolidRounded}
                  size={20}
                  color="#3A3A3A"
                  strokeWidth={0.2}
                />
              </IconButton>
              <Menu
                id={`${row.id}`}
                className='table-action-menu'
                MenuListProps={{
                  'aria-labelledby': 'long-button',
                }}
                anchorEl={anchorActionEl[row.id]}
                open={Boolean(anchorActionEl[row.id])}
                onClose={() => setAnchorActionEl({ ...anchorActionEl, [row.id]: null })}
                slotProps={{ paper: {
                  style: {
                    maxHeight: 'none',
                    width: '19ch',
                  },
                }}}
              >
                              <>
  {row.isActive === true && (
    <>
      {row.isPaused === true ? (
        checkEventPermission('LISTTRIGGER_PAUSE') && (
          <MenuItem onClick={() => handleUpdatePauseResume(row.id, 'resume')}>
            <span className="text-muted font-normal">Resume</span>
          </MenuItem>
        )
      ) : (
        checkEventPermission('LISTTRIGGER_PAUSE') && (
          <MenuItem onClick={() => handleUpdatePauseResume(row.id, 'pause')}>
            <span className="text-muted font-normal">Pause</span>
          </MenuItem>
        )
      )}

      {checkEventPermission('LISTTRIGGER_ACTIVE') && (
        <MenuItem onClick={() => handleupdatestatus(row.id, row.isActive, row.listTriggerName)}>
          <span  className="text-muted font-normal">Deactivate</span>
        </MenuItem>
      )}
    </>
  )}

  {row.isActive === false && checkEventPermission('LISTTRIGGER_ACTIVE') && (
    <MenuItem onClick={() => handleupdatestatus(row.id, row.isActive, row.listTriggerName)}>
      <span  className="text-muted font-normal">Activate</span>
    </MenuItem>
  )}
</>

                 {checkEventPermission("LISTTRIGGER_DUPLICATE") && 
                <MenuItem onClick={() => handleCopyTemplate(row.id, row.listTriggerName)}>
                  <span  className='text-muted font-normal'>Duplicate</span>
                </MenuItem>
      }
                {(checkEventPermission('LISTTRIGGER_DOWNLOAD_REPORT') && moment(row.startDate).isBefore(moment())) && (
                  <MenuItem onClick={() => handleDownloadReport(row.id, row.listTriggerName)}>
                    <span  className='text-muted font-normal'>Summary Report</span>
                  </MenuItem>
                )}
                {(checkEventPermission('LISTTRIGGER_DOWNLOAD_STANDARD_REPORT') && moment(row.startDate).isBefore(moment())) && (
                  <MenuItem onClick={() => handleDownloadStandardReport(row.id, row.listTriggerName)}>
                    <span className='text-muted font-normal'>Standard Report</span>
                  </MenuItem>
                )}
                {(checkEventPermission('LISTTRIGGER_DOWNLOAD_CUSTOM_REPORT') && moment(row.startDate).isBefore(moment())) && (
                  <MenuItem onClick={() => handleCustomReport(row.id, row.listTriggerName)}>
                    <span  className='text-muted font-normal'>Custom Report</span>
                  </MenuItem>
                )}
                {checkEventPermission("LISTTRIGGER_DELETE") && 
                <MenuItem onClick={() => handleDeleteTemplate(row.id, row.listTriggerName)}>
                  <span style={{ color: '#F13139' }}>Delete</span>
                </MenuItem>
               }
              </Menu>
            </div>
      }
          </div>
        )
      },
      sortable: false
    },

  ]
  return (
    <>
      <h2 className="text-2xl font-semibold text-title">List Trigger Overview</h2>
      <div className="mt-[20px] mb-[20px] live-outreach-container">
        <Grid container spacing={2} alignItems={'center'}>
          <Grid item xs={12} sm={6} md={6} lg={4} >
            <div className="w-full">
              <input type="text" placeholder="Search by list trigger name or id" className="input input-bordered search-input-white focus:ring-0 focus:outline-none border-[#E6ECF2] font-normal text-14 text-muted w-full" onChange={handleSearch} />
            </div>
          </Grid>
          <Grid item xs={12} md={12} lg={12} xl={6} order={{ xs: 2, md: 2, lg: 2, xl: 1 }} sx={{ display: 'flex', alignItems: 'center' }} className='select-client'>
            <div className='mr-[20px] status-autocomplete'>
            <FormControl fullWidth>
                <Autocomplete
                  options={campaigns}
                  // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
                  getOptionLabel={(option: any) => option?.name || ''}
                  popupIcon={
                    <HugeiconsIcon
                      icon={ArrowDown01Icon}
                      size={18}
                      color="#3A3A3A"
                      strokeWidth={0.2}

                    />
                  }
                  isOptionEqualToValue={(option, value) => option?.id === value?.id}
                  onChange={(_, selectedTrigger) => handleSearchByTrigger(selectedTrigger)}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Campaign"
                      placeholder="Select Campaign"
                      variant="outlined"
                      sx={{
                        '& .MuiOutlinedInput-root': {
                          borderRadius: '40px',
                          height: '40px',
                          width: '200px',
                        },
                      }}
                    />
                  )}
                  sx={{
                    '& .MuiAutocomplete-clearIndicator': {
                      marginRight: '-12px'
                    },
                    '& .MuiAutocomplete-input': {
                      width: '70%'
                    }
                  }}
                />
              </FormControl>
            </div>
            <div className='mr-[20px] status-autocomplete'>
            <FormControl fullWidth>
                <Autocomplete
                  options={options}
                  getOptionLabel={(option) => option.label}
                  popupIcon={
                    <HugeiconsIcon
                      icon={ArrowDown01Icon}
                      size={18}
                      color="#3A3A3A"
                      strokeWidth={0.2}

                    />
                  }
                  onChange={(event, newValue) => handleTemplateValue(newValue)}
                  //disableClearable
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Status"
                      placeholder="Select Status"
                      variant="outlined"
                      sx={{
                        '& .MuiOutlinedInput-root': {
                          borderRadius: '40px',
                          height: '40px',
                          width: '200px', // Increased width
                        },
                      }}
                    />
                  )}
                  sx={{
                    '& .MuiAutocomplete-clearIndicator': {
                      marginRight: '-12px'
                    },
                    '& .MuiAutocomplete-input': {
                      width: '70%'
                    }
                  }}

                />
              </FormControl>
            </div>
            
          </Grid>
          <Grid item xs={6} md={6} lg={6} xl={2} order={{ xs: 1, md: 1, lg: 1, xl: 1 }} className='bulk-action'>
            {checkEventPermission("LISTTRIGGER_ADD") && (
              <div className="justify-end flex">
              <GradientButton color='red' onClick={handleAddTemplateClick}>
                <span style={{
                  width: "20px",
                  height: "20px",
                  background: "#fff",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  borderRadius: "50px",
                  marginRight: "5px"
                }}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="19" viewBox="0 0 19 19" fill="none">
                    <path d="M17.5411 10.3185H1.03183C0.467764 10.3185 0 9.85078 0 9.28671C0 8.72265 0.467764 8.25488 1.03183 8.25488H17.5411C18.1052 8.25488 18.573 8.72265 18.573 9.28671C18.573 9.85078 18.1052 10.3185 17.5411 10.3185Z" fill="#F13139" />
                    <path d="M9.28671 18.573C8.72265 18.573 8.25488 18.1052 8.25488 17.5411V1.03183C8.25488 0.467764 8.72265 0 9.28671 0C9.85078 0 10.3185 0.467764 10.3185 1.03183V17.5411C10.3185 18.1052 9.85078 18.573 9.28671 18.573Z" fill="#F13139" />
                  </svg>
                </span>
                Add New List Trigger
              </GradientButton>
              </div>
            )}
          </Grid>
        </Grid>
      </div>
      <div className='data-table-container campaign-table mb-10 template-table-container'>
        <CustomDataTable
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
          columns={columns}
          data={templateSearchData}
          pagination
          progressPending={loading}
        />

        <MUIModal title='Add New Template' openModal={openAddTemplateModal} closeModal={handleCloseAddTemplateModal} width={'50%'} >
          <AddTriggerForm />
        </MUIModal>

        <BootstrapDialog
          onClose={handleDeleteTemplateClose}
          aria-labelledby="customized-dialog-title"
          open={showDeleteTemplateModal}
          PaperProps={{
            sx: {
              width: '550px',
              height: '200px'
            },
          }}
        >
          <DialogTitle sx={{ m: 0, p: 2, color: '#3A3A3A', fontSize: '18px', fontWeight: '600' }} id="customized-dialog-title">
            Delete Trigger
          </DialogTitle>

          <IconButton
            aria-label="close"
            onClick={handleDeleteTemplateClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <HugeiconsIcon
              icon={MultiplicationSignStrokeStandard}
              size={24}
              color="currentcolor"
              strokeWidth={0.5}
            />
          </IconButton>
          <DialogContent>
            <p className='text-14 text-muted'>{ARE_YOU_SURE} {DELETE_TRIGGER} <span className='font-semibold'>{templateInfoData?.templateName}</span>?</p>
          </DialogContent>
          <DialogActions sx={{ background: '#F9F9F9' }}>

            <OutlineButton color='gray' onClick={handleDeleteTemplateClose} width='100px'>Cancel</OutlineButton>

            <GradientButton type='button' color='red' onClick={handleDeleteTemplateConfirm} width='100px'>{!isModalSaveLoading ? 'Delete' : <span className="loading loading-spinner loading-xs text-white"></span>}</GradientButton>
          </DialogActions>
        </BootstrapDialog>

        <BootstrapDialog onClose={handleCopyTemplateClose} aria-labelledby="customized-dialog-title" open={showCopyTemplateModal} PaperProps={{ sx: { width: '550px', height: '200px' }, }}>
          <DialogTitle sx={{ m: 0, p: 2, color: '#3A3A3A', fontSize: '18px', fontWeight: '600' }} id="customized-dialog-title">
            Duplicate Trigger
          </DialogTitle>
          <IconButton aria-label="close" onClick={handleCopyTemplateClose} sx={{ position: 'absolute', right: 8, top: 8, color: (theme) => theme.palette.grey[500], }}>
            <HugeiconsIcon
              icon={MultiplicationSignStrokeStandard}
              size={24}
              color="currentcolor"
              strokeWidth={0.5}
            />
          </IconButton>
          <DialogContent>
            <p className='text-14 text-muted'>{ARE_YOU_SURE} {COPY_TRIGGER} <span className='font-semibold'>{templateInfoData?.templateName}</span>?</p>
          </DialogContent>
          <DialogActions sx={{ background: '#F9F9F9' }}>
            <OutlineButton color='gray' onClick={handleCopyTemplateClose} width='100px'>Cancel</OutlineButton>
            <GradientButton type='button' color='red' onClick={handleCopyTemplateConfirm} width='100px'>{!isModalSaveLoading ? 'Duplicate' : <span className="loading loading-spinner loading-xs text-white"></span>}</GradientButton>
          </DialogActions>
        </BootstrapDialog>

        <BootstrapDialog onClose={handleupdatestatusClose} aria-labelledby="customized-dialog-title" open={showDeactivateTemplateModal} PaperProps={{ sx: { width: '550px', height: '200px' }, }}>
          <DialogTitle sx={{ m: 0, p: 2, color: '#3A3A3A', fontSize: '18px', fontWeight: '600' }} id="customized-dialog-title">
            {templateInfoData?.newStatus === true ? "Deactivate Trigger" : "Activate Trigger"}
          </DialogTitle>
          <IconButton aria-label="close" onClick={handleupdatestatusClose} sx={{ position: 'absolute', right: 8, top: 8, color: (theme) => theme.palette.grey[500], }}>
            <HugeiconsIcon
              icon={MultiplicationSignStrokeStandard}
              size={24}
              color="currentcolor"
              strokeWidth={0.5}
            />
          </IconButton>
          <DialogContent>
            <p className='text-14 text-muted'>{ARE_YOU_SURE}{" "}{templateInfoData?.newStatus == true ? "deactivate the trigger" : "activate the trigger"}{" "}<span className='font-semibold'>{templateInfoData?.templateName}</span>?</p>
          </DialogContent>

          <DialogActions sx={{ background: '#F9F9F9' }}>
            <OutlineButton color='gray' onClick={handleupdatestatusClose} width='130px'>Cancel</OutlineButton>
            <GradientButton type='button' color='red' onClick={handleUpdateStatusConfirm} width='130px'>{!isModalSaveLoading ? (templateInfoData?.newStatus == true ? "Deactivate" : "Activate") : (<span className="loading loading-spinner loading-xs text-white"></span>)}</GradientButton>
          </DialogActions>

        </BootstrapDialog>
        <BootstrapDialog onClose={handleUpdatePauseResumeClose} aria-labelledby="customized-dialog-title" open={updatePauseResume} PaperProps={{ sx: { width: '550px', height: '200px' }, }}>
          <DialogTitle sx={{ m: 0, p: 2, color: '#3A3A3A', fontSize: '18px', fontWeight: '600' }} id="customized-dialog-title">
            {updateType === "resume" ? "Resume Trigger" : "Pause Trigger"}
          </DialogTitle>
          <IconButton aria-label="close" onClick={handleUpdatePauseResumeClose} sx={{ position: 'absolute', right: 8, top: 8, color: (theme) => theme.palette.grey[500], }}>
            <HugeiconsIcon
              icon={MultiplicationSignStrokeStandard}
              size={24}
              color="currentcolor"
              strokeWidth={0.5}
            />
          </IconButton>
          <DialogContent>
            <p className='text-14 text-muted'>{ARE_YOU_SURE}{" "}{updateType === "resume" ? "resume the trigger" : "pause the trigger"}{" "}<span className='font-semibold'>{templateInfoData?.templateName}</span>?</p>
          </DialogContent>

          <DialogActions sx={{ background: '#F9F9F9' }}>
            <OutlineButton color='gray' onClick={handleUpdatePauseResumeClose} width='130px'>Cancel</OutlineButton>
            <GradientButton type='button' color='red' onClick={handleUpdatePauseResumeConfirm} width='130px'>{!isModalSaveLoading ? (updateType === "resume" ? "Resume" : "Pause") : (<span className="loading loading-spinner loading-xs text-white"></span>)}</GradientButton>
          </DialogActions>

        </BootstrapDialog>
        <TemplatePreview
          isOpen={isPreviewModalOpen}
          onClose={() => setIsPreviewModalOpen(false)}
          content={previewContent}
        />
      </div>

      <MUIModal title='Download Custom Report' openModal={customReportModal} closeModal={handleCloseCustomReport} width={'50%'} >
        <ExportTriggerCustomReport closeModal={handleCloseCustomReport} id={triggerId} name={triggerName} />
      </MUIModal>
    </>
  );
};


export default TriggerList;
